import { featureList } from "@/mocks/content";

const iconColor: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-100 py-20 md:py-24">
      <div className="container-site">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold text-primary-700">
            核心功能
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            一套方案,解决所有看番卡顿
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            从自动选源到手动秒切,小猴看番用多线路聚合,让你在任何网络环境下都能稳定畅快追更。
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featureList.map((feature) => (
            <article
              key={feature.title}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-full text-2xl ${iconColor[feature.accent]}`}>
                <i className={feature.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{feature.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{feature.desc}</p>
              <a
                href="#anime"
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-700"
              >
                了解详情
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}